module.exports = __webpack_public_path__ + "static/media/cad.11149433.jpg";